import { CSSProperties } from "react";

/** Fallbacks keep the button named even when Contentful omits the key. */
const DEFAULT_PREVIOUS_LABEL = "Previous slide";
const DEFAULT_NEXT_LABEL = "Next slide";
import { Button } from "@components/shared/core/Button";
import cx from "classnames";

export const ArrowButton = ({
    className = "",
    disabled = false,
    ariaLabel = "",
    direction = "next",
    style,
    onClick,
  }: {
    className?: string;
    disabled?: boolean;
    ariaLabel: string | null;
    direction?: "previous" | "next";
    style?: CSSProperties;
    onClick: () => void;
  }) => {
    const accessibleName =
      ariaLabel ||
      (direction === "previous" ? DEFAULT_PREVIOUS_LABEL : DEFAULT_NEXT_LABEL);
    return (
      <Button
        disabled={disabled}
        variant="light-on-blur"
        size="inherit"
        className={cx("disabled:opacity-40", className)}
        aria-label={accessibleName}
        style={style}
        onClick={onClick}
      >
        <span className="flex justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            fill="none"
          >
            <path
              d="m8.5 1 7 7-7 7M14.833 8H1.5"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </Button>
    );
  };
